window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    //window.Popper = require('@popperjs/core');
    window.bootstrap = require('bootstrap');
    window.bsCustomFileInput = require("bs-custom-file-input");
    window.Swal = require("sweetalert2");
    window.lozad = require("lozad");

    require('./modules/jquery.md5.min');
    require('./modules/jquery.qrcode.min');
    require('./modules/jquery.serializejson.min');
    require('./modules/jquery.lazyload.min');

    //全站用自訂函式
    window.gfn = require('./modules/func');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
